import React, { useEffect, useContext, useState } from 'react'
import { ContextLoader } from '../context'
import loadFonts from '../helpers/loadFonts'
import SplitText from './SplitText'

const Loader = () => {

	const [isLoading, updateIsLoading] = useContext(ContextLoader)
	const [isTextVisible, updateIsTextVisible] = useState(false)

	// General loading handler
	useEffect(() => {
		// Combine loading promises
		setTimeout(() => {
			updateIsTextVisible(true)
		}, 100);
		handleFontsLoad().then(() => {
			setTimeout(() => {
				updateIsLoading(false)
			}, 1500);
		})
	}, [updateIsLoading])

	// Load fonts
	const handleFontsLoad = () => {
		return new Promise(
			(resolve) => {
				loadFonts().then(() => {
					resolve()
				})
			}
		)
	}

	return (
		<div className={`Loader ${!isLoading ? 'Loader--Ended' : ''}`}>
			<SplitText splitBy="chars" forceExecutionBeforeLoadingEnd>
				<div className={`Loader__Text ${isTextVisible ? 'isVisible' : ''}`}>
					Proof
				</div>
			</SplitText>
		</div>
	)
}

export default Loader